export const CHATGPT_URL = 'https://chatgpt.com/plugins/plugin_asdk_app_6ac34fe17ad08191a720849c9f43639b';
export const CLAUDE_URL = 'https://claude.ai/directory/fiverr-mcp';

export const BI_EVENTS = {
    viewedButton: 'viewed_connect_to_your_ai',
    clickedButton: 'clicked_on_connect_to_your_ai',
    viewedDropdown: 'viewed_connect_to_your_ai_dropdown',
    clickedOption: 'clicked_on_connect_to_your_ai_option',
} as const;

export const BI_OPTIONS = {
    chatgpt: 'chatgpt',
    claude: 'claude',
    learnMore: 'learn_more',
} as const;
